interface AssetManifest {
    version: string;
    files: Record<string, string>;
}

export const checkVersion = async (): Promise<void> => {
    try {
        const response = await fetch('/asset-manifest.json');
        const manifest: AssetManifest = await response.json();
        
        const currentVersion = localStorage.getItem('appVersion');
        
        if (currentVersion && currentVersion !== manifest.version) {
            // Очищаем только кэш Service Worker
            if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(
                    cacheNames.map(cacheName => caches.delete(cacheName))
                );
            }
            
            // Сохраняем новую версию
            localStorage.setItem('appVersion', manifest.version);
            
            // Перезагружаем страницу
            window.location.reload();
        } else {
            // Сохраняем текущую версию
            localStorage.setItem('appVersion', manifest.version);
        }
    } catch (error) {
        console.error('Failed to check version:', error);
    }
}; 